import { render, staticRenderFns } from "./NoCvFound.vue?vue&type=template&id=56816ed8&"
import script from "./NoCvFound.vue?vue&type=script&lang=js&"
export * from "./NoCvFound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports